import { canv } from '@/canv/global.js'

export class shapeArrowLeftRight {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 2/3 - 2 * horizontalPadding;
        var allowedHeight = height * 3/5 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height / 2);
        canv.ctx.lineTo(x + width / 3, y);
        canv.ctx.lineTo(x + width / 3, y + height / 5);
        canv.ctx.lineTo(x + width * 2/3, y + height / 5);
        canv.ctx.lineTo(x + width * 2/3, y);
        canv.ctx.lineTo(x + width, y + height / 2);
        canv.ctx.lineTo(x + width * 2/3, y + height);
        canv.ctx.lineTo(x + width * 2/3, y + height * 4/5);
        canv.ctx.lineTo(x + width / 3, y + height * 4/5);
        canv.ctx.lineTo(x + width / 3, y + height);
        canv.ctx.lineTo(x, y + height / 2);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="70" height="80" viewBox="0 0 70 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M70 40.0001L44.9188 0V24.1813H25.0812V0L0 40.0001L25.0812 80V55.8187H44.9188V80L70 40.0001Z" fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26 14.5L17.0424 2V9.55666H9.95757V2L1 14.5L9.95757 27V19.4433H17.0424V27L26 14.5Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
